<mat-icon fxFlexAlign="center">{{data.iconType}}</mat-icon>
<span fxFlex fxFlexAlign="center" class="padding-left-sm">{{ data.message }}</span>
<button mat-icon-button (click)="snackBarRef.dismiss()">
    <mat-icon>clear</mat-icon>
</button>